// extracted by mini-css-extract-plugin
export default {"container":"Diwali_container__dXVA-","content":"Diwali_content__CDEsZ","testimony":"Diwali_testimony__MT26T"};